import React, { useState, useEffect, Fragment } from 'react';
import './MultiSelectVertical.scss';
import Button from '../../partials/Button/Button'
import FeedbackBlock from '../../partials/FeedbackBlock'
import Scroll from '../../partials/Scroll/Scroll';

const MultiSelectVertical = (props) => {

  const { data, onComplete } = props;

  const [optionSelected, setOptionSelected] = useState([]);
  const [blockSelection, setBlockSelection] = useState(false);
  const [errors, SetErrors] = useState(false);

  const resetStep = () => {
    setOptionSelected([]);
    setBlockSelection(false);
    SetErrors(false);
  }

  const passValidation = () => {
    
    let err = 0;
    data.options.forEach((option, optionIndex) => {
      if(option.correct) {
        if(optionSelected.indexOf(optionIndex) === -1) {
          err += 1;
        }
      } else {
        if(optionSelected.indexOf(optionIndex) !== -1) {
          err += 1;
        }
      }
    });
    
    if(err > 0) {
      SetErrors(true);
    } else {
      SetErrors(false);
    }
    
  };

  return <div className="single-select-vertical">
  <div className="marg_top_inst">
    <div className="wdth">
      <h2 dangerouslySetInnerHTML={{__html: data.questionText}} />
    </div>
    <div className="wdth">
      <div className="options">
        {
          data.options.map( (option, optionIndex) => (
            <div
              key={`option-${optionIndex}`}
              className={`option ${optionSelected.indexOf(optionIndex) !== -1 ? 'selected' : 'not-selected'}`} 
              onClick={ () => { 
                if(!blockSelection) {
                  if(optionSelected.includes(optionIndex)) {
                    setOptionSelected(optionSelected.filter((item) => item !==optionIndex));
                  } else {
                    setOptionSelected([
                      ...optionSelected,
                      optionIndex
                    ]);
                  }
                }
                  }}>
                {option.text} 
                { blockSelection && optionSelected.indexOf(optionIndex) !== -1 &&
                  <>
                  { !option.correct ?
                    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30">
                    <g id="icn-Correct" transform="translate(-119 -317)">
                      <g id="Ellipse_242" data-name="Ellipse 242" transform="translate(119 317)" fill="#63c132" stroke="#eee5e9" stroke-width="2">
                        <circle cx="15" cy="15" r="15" stroke="none"/>
                        <circle cx="15" cy="15" r="14" fill="none"/>
                      </g>
                      <path id="Icon_awesome-check" data-name="Icon awesome-check" d="M7.083,19.823.305,13.045a1.043,1.043,0,0,1,0-1.475L1.78,10.1a1.043,1.043,0,0,1,1.475,0L7.82,14.662,17.6,4.883a1.043,1.043,0,0,1,1.475,0l1.475,1.475a1.043,1.043,0,0,1,0,1.475L8.558,19.823A1.043,1.043,0,0,1,7.083,19.823Z" transform="translate(123.573 320.647)" fill="#eee5e9"/>
                    </g>
                  </svg>
                    :
                    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30">
                      <g id="icn-Incorrect" transform="translate(-119 -317)">
                        <g id="Ellipse_242" data-name="Ellipse 242" transform="translate(119 317)" fill="#a31621" stroke="#eee5e9" stroke-width="2">
                          <circle cx="15" cy="15" r="15" stroke="none"/>
                          <circle cx="15" cy="15" r="14" fill="none"/>
                        </g>
                        <path id="Icon_ionic-ios-close" data-name="Icon ionic-ios-close" d="M21.744,19.742l6.04-6.04a1.415,1.415,0,0,0-2-2l-6.04,6.04L13.7,11.7a1.415,1.415,0,1,0-2,2l6.04,6.04-6.04,6.04a1.415,1.415,0,0,0,2,2l6.04-6.04,6.04,6.04a1.415,1.415,0,0,0,2-2Z" transform="translate(114.259 312.258)" fill="#eee5e9"/>
                      </g>
                    </svg>
                  }
                  </>
                }
            </div>
          ))
        }
      </div>
      <div className="notes">
        {
          data.options.map( (option, optionIndex) => (
            <Fragment key={`note-${optionIndex}`}>
              <div className={`notes ${optionSelected===optionIndex ? 'selected' : 'not-selected'}`} dangerouslySetInnerHTML={{ __html:option.notes }}></div>
              { blockSelection && optionSelected===optionIndex &&

              <FeedbackBlock variant="popup" status={option.correct ? 'success':'failed'} caption={option.correct ? 'Correct':'Incorrect'}>
                <Scroll>
                  <div dangerouslySetInnerHTML={{ __html: option.feedback.body }}></div>
                </Scroll>
              </FeedbackBlock>
              }
            </Fragment>
          ))
        }
      </div>
      { optionSelected.length > 0 &&
        <div className="action">
          { errors && blockSelection &&
            <Button text="Retry" className={"center"}size="wide"
            // icon={ <i className="fa fa-undo mr-1"></i>}
            onClick={resetStep} />

          }
          { !blockSelection &&
            <Button text={data.buttonText} className={"center"}size="wide"
            // icon={ data.icon !== "" && <i className={`fa fa-${data.icon} mr-1`}></i> }
            onClick={() => { 
              setBlockSelection(true);
              passValidation();
            }} />
          }
          { !errors && blockSelection ? 
            <Button text="Next" className={"center"}size="wide" onClick={() => { onComplete(errors) }} />
            :
            <>
              { data.canContinueWithErrors && blockSelection &&  <Button text="Next" className={"center"}size="wide" onClick={() => { onComplete(errors) } } />}
            </>
          }
        </div>
      } 
    </div>
    </div>
  </div>
}

export default MultiSelectVertical;